<script setup lang="ts">
export type SizeArea = {
  key: string
  title: string | None
  name: string | None
  value: string | None
  unit: string | None
}

defineProps<{
  on?: boolean
  title: string | None
  measurments: string | None
  instructions: string | None
  areas: SizeArea[]
}>()
</script>

<template>
  <div :class="[$style.card, on && 'on']">
    <div v-if="title" class="_pb2 _pt04 _row _ctrY">
      <h3 class="_fs09 _mono _ctr _pl08 _pr08 _br14" :class="$style.title">{{ title }}</h3>
    </div>

    <div v-for="item in areas" :key="item.key" class="_hm40 _w70ch _row _gap2 _pb14 _fs09 _lh14">
      <span :class="$style.nr" class="_mono _fs14 _fw-xxl">{{ item.name }}</span>

      <div class="_col">
        <span class="_fw-xl _fs09">{{ item.title }}</span>

        <div class="_fs1 _fw-l">
          <template v-if="helpers.isDef(item.value)"
            >{{ item.value }}<div v-if="item.unit" class="_italic _inline _noline _pl04">{{ item.unit }}</div></template
          >
          <template v-else>-</template>
        </div>
      </div>
    </div>

    <div v-if="measurments" class="_fs09 _lh14 _pt1 _pb1 _pl04 _pr04">* {{ measurments }}</div>
    <div v-if="instructions" class="_fs09 _lh14 _pt1 _pb1 _pl04 _pr04">* {{ instructions }}</div>
  </div>
</template>

<style module>
.card {
  composes: global(_pr04);
  composes: global(_pl04);
  composes: global(_pb4);

  opacity: 0.4;
  backface-visibility: hidden;
  image-rendering: -webkit-optimize-contrast;
  -webkit-transform: translateZ(0) scale(1, 1);
  transition:
    opacity 100ms var(--tran2),
    background 100ms var(--tran2),
    color 100ms var(--tran2);
}
.card:global(.on) {
  opacity: 1;
  background: hsla(240, 33.3%, 99.4%, 0.9);
  --color: var(--blue3);
}
.title {
  background: var(--color, var(--black-4));
  composes: global(_c0);
  composes: global(_h50);
  composes: global(_wmin60);
}

.nr {
  composes: global(_svg18);
  composes: global(_pt06);
  composes: global(_lh1);
  composes: global(_ls-xs);
  align-self: flex-start;
}
</style>
